import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import { OnChange } from 'react-final-form-listeners';
import Select from '../../../shared/components/form/Select';

const AcademicCalendarFilter = (props) => {
  const { lastFilter, t, filterClick, schoolTerms } = props;
  const [filter, setFilter] = useState({});

  const filterChange = (field, value) => {
    if (value) {
      const updatedFilter = { ...filter };
      updatedFilter[field] = value;
      setFilter(updatedFilter);
    } else {
      setFilter({});
    }
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
    }
  }, []);

  return (
    <Fragment>
      <Form
        initialValues={filter}
        onSubmit={filterClick}
        render={() => (
          <form className="form">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.school-terms')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="schoolTerms"
                  component={Select}
                  options={schoolTerms}
                  placeholder={t('general.school-terms')}
                />
                <OnChange name="schoolTerms">
                  {(values) => filterChange('schoolTerms', values)}
                </OnChange>
              </div>
              <ButtonToolbar className="filter-button">
                <Button color="success" onClick={() => filterClick(filter)}>
                  {t('general.filter')}
                </Button>
              </ButtonToolbar>
            </div>
          </form>
        )}
      />
    </Fragment>
  );
};

AcademicCalendarFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
  schoolTerms: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

AcademicCalendarFilter.defaultProps = {
  lastFilter: null,
};

export default withTranslation('common')(AcademicCalendarFilter);
